/**
 * Скрипт выключает ховер на мобильных
 *  @module CanHover
 */
const canHover = !matchMedia('(hover: none)').matches;
if (canHover) {
    document.body.classList.add('js-can-hover');
}
